// useSearchFormik.js
import * as Yup from "yup";
import { useFormik } from "formik";
import { SearchAPI } from "../network/APIs/APIs";
import { AllComplaintAPI } from "../network/APIs/APIs";

/**
 * Custom hook for managing search form using Formik and Yup validation.
 * @component
 * @memberof Hooks
 * @param {Object} params - Parameters for the search form.
 * @param {number} params.selectedTab - Index of the selected search tab.
 * @param {Function} params.setSelectedValueOfTab - Function to set the selected search value.
 * @param {Function} params.setResultSearchedData - Function to set the result data from Search API.
 * @param {Function} params.setResultSearchedData1 - Function to set the result data from All Complaint API.
 * @param {string} params.token - Authorization token for API requests.
 * @param {Function} params.handleDialogOfApplicationOpen - Function to handle opening the search dialog.
 * @param {Function} params.handleCloseSearchBarPopup - Function to close the search bar popup.
 * @param {Object} params.initialValues - Initial values for the form fields.
 *
 * @returns {Object} Formik instance for managing the search form.
 */
// export const useSearchFormik = ({ selectedTab, setSelectedValueOfTab, setResultSearchedData, setResultSearchedData1, token, handleDialogOfApplicationOpen, handleCloseSearchBarPopup, initialValues }) => {
//     return useFormik({
//         initialValues: initialValues,
//         validationSchema: Yup.object({
//             iv_reference_no: Yup.string().when('selectedTab', {
//                 is: () => selectedTab == "0",
//                 then: Yup.string().required('Enter 14 digit Reference No.').min(14, 'Reference No. should be 14 digits.').max(14, 'Reference No. should be 14 digits.'),
//                 otherwise: Yup.string().optional()
//             }),
//             iv_application_id: Yup.string().when('selectedTab', {
//                 is: () => selectedTab == "1",
//                 then: Yup.string().required('Enter Application ID.').min(17, 'Application ID. should be minimum 17 digits.').max(19, 'Application ID. should be maximum 19 digits.'),
//                 otherwise: Yup.string().optional()
//             }),
//             iv_cnic: Yup.string().when('selectedTab', {
//                 is: () => selectedTab == "2",
//                 then: Yup.string().required('Enter 13 digit CNIC.').min(13, 'CNIC should be 13 digits.').max(13, 'CNIC should be 13 digits.'),
//                 otherwise: Yup.string().optional()
//             }),
//             iv_applicant_name: Yup.string().when('selectedTab', {
//                 is: () => selectedTab == "3",
//                 then: Yup.string().required('Enter Applicant Name.').min(3, `Name can't be less than 3 alphabets.`),
//                 otherwise: Yup.string().optional()
//             }),
//         }),
//         onSubmit: async (values, { resetForm }) => {
//             let searchWord = '';

//             if (selectedTab === 0) {
//                 searchWord = values.iv_reference_no;
//                 setSelectedValueOfTab(searchWord);
//             } else if (selectedTab === 1) {
//                 searchWord = values.iv_application_id;
//                 setSelectedValueOfTab(searchWord);
//             } else if (selectedTab === 2) {
//                 searchWord = values.iv_cnic;
//                 setSelectedValueOfTab(searchWord);
//             } else if (selectedTab === 3) {
//                 searchWord = values.iv_applicant_name;
//                 setSelectedValueOfTab(searchWord);
//             }

//             const result = await AllComplaintAPI(token, searchWord);
//             if (result) {
//                 setResultSearchedData1(result);
//                 handleDialogOfApplicationOpen();
//                 handleCloseSearchBarPopup();
//                 resetForm();
//             }
//             const results = await SearchAPI(token, searchWord);
//             if (results) {
//                 setResultSearchedData(results);
//                 handleDialogOfApplicationOpen();
//                 handleCloseSearchBarPopup();
//                 resetForm();
//             }
//         },
//     });
// };


export const useSearchFormik = ({
    selectedTab,
    setSelectedValueOfTab,
    setResultSearchedData,
    setResultSearchedData1,
    token,
    handleDialogOfApplicationOpen,
    handleCloseSearchBarPopup,
    initialValues,
    setViewBackdrop, // ✅ You passed it — now use it
  }) => {
    return useFormik({
      initialValues,
      validationSchema: Yup.object({
        iv_reference_no: Yup.string().when('selectedTab', {
          is: () => selectedTab == "0",
          then: Yup.string().required('Enter 14 digit Reference No.').min(14).max(14),
          otherwise: Yup.string().optional(),
        }),
        iv_application_id: Yup.string().when('selectedTab', {
          is: () => selectedTab == "1",
          then: Yup.string().required('Enter Application ID.').min(17).max(19),
          otherwise: Yup.string().optional(),
        }),
        iv_cnic: Yup.string().when('selectedTab', {
          is: () => selectedTab == "2",
          then: Yup.string().required('Enter 13 digit CNIC.').min(13).max(13),
          otherwise: Yup.string().optional(),
        }),
        iv_applicant_name: Yup.string().when('selectedTab', {
          is: () => selectedTab == "3",
          then: Yup.string().required('Enter Applicant Name.').min(3),
          otherwise: Yup.string().optional(),
        }),
      }),
      onSubmit: async (values, { resetForm }) => {
        setViewBackdrop(true); // ✅ Show backdrop
        let searchWord = '';
  
        if (selectedTab === 0) {
          searchWord = values.iv_reference_no;
        } else if (selectedTab === 1) {
          searchWord = values.iv_application_id;
        } else if (selectedTab === 2) {
          searchWord = values.iv_cnic;
        } else if (selectedTab === 3) {
          searchWord = values.iv_applicant_name;
        }
  
        setSelectedValueOfTab(searchWord);
  
        try {
          // const result = await AllComplaintAPI(token, searchWord);
          // if (result) {
          //   setResultSearchedData1(result);
          // }
  
          const results = await SearchAPI(token, searchWord);
          if (results) {
            setResultSearchedData(results);
          }
  
          handleDialogOfApplicationOpen();
          handleCloseSearchBarPopup();
          resetForm();
        } catch (error) {
          console.error('Search error:', error);
        } finally {
          setViewBackdrop(false); // ✅ Hide backdrop after both API calls
        }
      },
    });
  };
  